import {
    FETCH_OPTIONS,
    UPDATE_REPORT_SETTINGS
}  from './actionTypes';

export const fetchOptions = () => ({
    type: FETCH_OPTIONS,
    payload: {}
});

export const updateReportSettings = (reportSettings) =>(
    {
        type: UPDATE_REPORT_SETTINGS,
        payload: reportSettings
    }
)